"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DragAndDropImage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_dropzone_1 = require("react-dropzone");
const useIsMobile_1 = require("../../../hooks/mobile/useIsMobile");
const react_i18next_1 = require("react-i18next");
const DragAndDropImage = ({ uploadImage, imgUrl, }) => {
    const [preview, setPreview] = (0, react_1.useState)(null);
    const isMobile = (0, useIsMobile_1.useIsMobile)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const onDrop = (0, react_1.useCallback)((acceptedFiles) => {
        const file = acceptedFiles[0];
        if (file) {
            const url = URL.createObjectURL(file);
            setPreview(url);
            uploadImage(acceptedFiles);
        }
    }, []);
    const { getRootProps, getInputProps, isDragActive } = (0, react_dropzone_1.useDropzone)({
        onDrop,
        accept: {
            'image/*': [],
        },
    });
    const containerStyles = {
        border: '2px dashed #ccc',
        padding: '20px',
        textAlign: 'center',
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: isMobile ? '100%' : '34%',
        height: isMobile ? '200px' : '200px',
        borderRadius: '10px',
        flexDirection: 'column',
        overflow: 'hidden',
    };
    const imageStyles = {
        width: '100%',
        height: '100%',
        objectFit: 'contain',
        borderRadius: '10px',
    };
    return ((0, jsx_runtime_1.jsxs)("div", { ...getRootProps(), style: containerStyles, children: [(0, jsx_runtime_1.jsx)("input", { ...getInputProps() }), preview ? ((0, jsx_runtime_1.jsx)("img", { src: preview, alt: "Preview", style: imageStyles })) : imgUrl ? ((0, jsx_runtime_1.jsx)("img", { src: imgUrl, alt: "Preview", style: imageStyles })) : isDragActive ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("span", { children: (0, jsx_runtime_1.jsx)("i", { className: 'pi pi-image' }) }), (0, jsx_runtime_1.jsx)("p", { children: t('dropImageHere') })] })) : ((0, jsx_runtime_1.jsxs)("div", { className: 'flex flex-col justify-center', children: [(0, jsx_runtime_1.jsx)("span", { children: (0, jsx_runtime_1.jsx)("i", { className: 'pi pi-image' }) }), (0, jsx_runtime_1.jsx)("p", { children: t('dragAndDropOrClick') })] }))] }));
};
exports.DragAndDropImage = DragAndDropImage;
